import { render, staticRenderFns } from "./BnplB2bApplicationSuccess.vue?vue&type=template&id=6c985cb8&"
import script from "./BnplB2bApplicationSuccess.vue?vue&type=script&lang=js&"
export * from "./BnplB2bApplicationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BnplB2bApplicationSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports